import "./verify_password.css"
import register from "../../../assets/register_img.webp";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {setVerifyInfo} from "../../../redux/verify_password_store";
import {connect} from "react-redux";
import apiClient from "../../../utils/axios";

const HOST = `${process.env.REACT_APP_API_URL}/api/accounts/verifytoken`

function VerifyPassword({verify, setVerifyInfo}) {

    const {t} = useTranslation()
    const [verifyToken, setVerifyToken] = useState('');

    const [verifyErrors, setVerifyErrors] = useState({
        email: "",
        new_password: "",
        confirm_new_password: "",
        verify_token: ''
    })

    useEffect(() => {
        const token = (new URLSearchParams(window.location.search)).get("token")

        if (token) {
            setVerifyToken(token)
        }
    }, [])

    const isEmailValid = (email) => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

        if (!email?.includes("@")) {
            setVerifyErrors((prevErrors) => ({
                ...prevErrors,
                email: t('errors.email_validation'),
            }));
            return false;
        }

        if (email.toLowerCase().endsWith(".ca")) {
            setVerifyErrors((prevErrors) => ({
                ...prevErrors,
                email: t('errors.canadian_email_error'),
            }));
            return false;
        }

        return emailRegex.test(email);
    };

    const isPasswordValid = (password) => {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,15}$/;
        return passwordRegex.test(password);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setVerifyErrors({
            email: "",
            new_password: "",
            confirm_new_password: ""
        });

        let isValid = true;

        if (!isEmailValid(verify.email)) {
            isValid = false;
        }

        if (!isPasswordValid(verify.new_password)) {
            setVerifyErrors((prevErrors) => ({
                ...prevErrors,
                new_password: t('errors.invalid_password'),
            }));
            isValid = false;
        }

        if (verify.new_password !== verify.confirm_new_password) {
            setVerifyErrors((prevErrors) => ({
                ...prevErrors,
                confirm_new_password: t('errors.conf_password_error'),
            }));
            isValid = false;
        }

        if (isValid) {
            verify_password()
        }
    };

    const verify_password = async () => {
        await apiClient.post(HOST, verify, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            }
        });
        setVerifyInfo({...verify});
    };

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setVerifyInfo({...verify, [name]: value});
    };

    return (
        <div className="flex">
            <div className="left_side">
                <img className="w-full" src={register} alt=""/>
            </div>
            <div className="right_side">
                <p className="verify_heading text-center font-normal sm:text-5xl text-2xl">{t('login.forgot_password')}</p>

                <form onSubmit={handleSubmit}>
                    <div className="flex flex-column align-items-center gap-3 pt-2">
                        <div className="w-full flex flex-column">
                            <input
                                value={verify.email}
                                name="email"
                                onChange={handleInputChange}
                                type="email"
                                className="verify_email_form w-full"
                                placeholder={t('login.email')}
                            />
                            {verifyErrors.email && <p className="text-red-500 text-xs mt-1">{verifyErrors.email}</p>}
                        </div>

                        <div className="w-full flex flex-column">
                            <input
                                value={verify.new_password}
                                name="new_password"
                                onChange={handleInputChange}
                                type="password"
                                className="verify_password_form w-full"
                                placeholder={t('login.new_password')}
                            />
                            {verifyErrors.new_password &&
                                <p className="text-red-500 text-xs mt-1">{verifyErrors.new_password}</p>}
                        </div>

                        <div className="w-full flex flex-column">
                            <input
                                value={verify.confirm_new_password}
                                name="confirm_new_password"
                                onChange={handleInputChange}
                                type="password"
                                className="verify_password_form w-full"
                                placeholder={t('login.confirm_new_password')}
                            />
                            {verifyErrors.confirm_new_password &&
                                <p className="text-red-500 text-xs mt-1">{verifyErrors.confirm_new_password}</p>}
                        </div>

                        <input
                            value={verifyToken}
                            name="verifyToken"
                            onChange={handleInputChange}
                            type="text"
                            className="verify_password_form w-full"
                            placeholder="Verify Token"
                        />
                    </div>
                    <div
                        className="flex justify-content-center align-items-center gap-5 sm:flex-row flex-column row-gap-3 pt-5">
                        <button type="submit"
                                className="verify_login_btn w-10rem flex justify-content-center align-items-center gap-2 text-white font-bold border-0 no-underline text-xl border-round-sm px-1 py-2">
                            {t('login.login')}
                        </button>
                        <Link to="/" className="no-underline">
                            <button
                                className="verify_cancel_btn w-10rem flex justify-content-center align-items-center gap-2 text-white font-bold border-0 no-underline text-xl border-round-sm px-1 py-2">
                                {t('login.cancel')}
                            </button>
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    verify: state.verify
});

const mapDispatchToProps = {
    setVerifyInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyPassword);